import TaxThresholdsPage from '@playground/features/dictionary/TaxThresholdsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/tax-thresholds'
)({
  component: TaxThresholdsPage,
})
